import React from 'react';
import { Input } from './Input';

export const StandartInput = (props) => {
    return (
        <Input
            variant="standard"
            size={'small'}
            {...props}
        />
    )
};
